import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Oryza from "./oryza/oryzamain";
import Header from "./oryza/partials/header";
import Footer from "./oryza/partials/footer";
import OryzaLandingPage from "./oryza/oryzalandingpage";
import ContactUs from "./oryza/partials/contactus";
import "./App.css";

function AppWrapper() {
  const location = useLocation();
  const showLayout = location.pathname !== "/";

  return (
    <div className="App">
      {showLayout && <Header />}
      <Routes>
        <Route path="/" element={<OryzaLandingPage />} />
        <Route path="/oryza" element={<Oryza />} />
        <Route path="/oryza-countactus" element={<ContactUs />} />
      </Routes>
      {showLayout && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
